export default "__VITE_ASSET__370e4c61__"